import React, { useState, useEffect, useContext, useRef } from "react";
import OrderComponent from "./OrderComponent";
import { api } from "../../../utils/Api";
import AliceCarousel from "react-alice-carousel";
import DataContext from "../../../utils/Context/DataContext";

import {
  Link,
  useParams,
  useOutletContext,
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
} from "@expo/vector-icons";

// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//   },
//   paper: {
//     marginRight: theme.spacing(2),
//   },
// }));

const handleDragStart = (e) => e.preventDefault();

const responsive = {
  0: { items: 1 },
  200: { items: 3 },
  300: { items: 4 },
  350: { items: 4 },
  548: { items: 4 },
  720: { items: 5 },
};

let timer: any;

export default function OutletOrders(props: any) {
  // const classes = useStyles();
  const OutletContext = useOutletContext();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const context : any = useContext(DataContext);
  const [grid_view, SetGridView] = useState(false);
  const [list_view, SetListView] = useState(true);
  const [id_value, SetIdValue] = useState(useParams());
  const [response_data, SetResponseData] = useState({});
  const [type, setType] = useState("all");
  const [tab_filter, SertTabFilter] = useState([
    { label: "All", value: "all" },
    { label: "Active", value: "active" },
    { label: "New", value: "new" },
    { label: "Finished", value: "finished" },
    { label: "Cancelled", value: "cancelled" },
  ]);
  // const [active_tab, SetActiveTab] = useState("All");
  const [width, SetWidth] = useState(innerWidth);
  const [have_new_order, SetHaveNewOrder] = useState(false);
  const [is_loading, SetIsLoading] = useState(false);
  // const [view_type, SetViewType] = useState("active");
  const [view_type, SetViewType] = useState(id_value.type);
  const [active_tab, SetActiveTab] = useState();
  // id_value.type
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log("useEffect On id_value change in order list  :", id_value);
  //   console.log("ProductAssign OutletContext :", OutletContext);
  //   setType(id_value.type);
  //   get_order(id_value.type);
  // }, [id_value]);

  
  // const location = useLocation();
  // useEffect(() => {
  //   console.log("Location changed", location);
  //   SetIdValue((prevalue: any) => {
  //     console.log("Location changed SetIdValue prevalue :", prevalue);
  //     return prevalue;
  //   });
  // }, [location]);

  let new_sample_value : any  = useParams();
  useEffect(()=>{
    // setType(new_sample_value.type);
    // SetActiveTab(new_sample_value.type);
    // get_order(new_sample_value.type);
    SetActiveTab((prevalue : any)=>{
      console.log("new_sample_value :",new_sample_value,prevalue)

      if(prevalue != new_sample_value.type){
        prevalue = new_sample_value.type
        get_order(new_sample_value.type);
      }else{

      }
      return prevalue;
    })
  },[new_sample_value])

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);
  // };

  async function get_order(view: any) {
    SetViewType(view);
    SetIsLoading(true);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };

    let response;

    // if (id_value.order_id) {
    //   pass_data.get.order_id = id_value.order_id;

    //   response = await api("/outlet/order_details", pass_data);
    // }

    if (view) {
      pass_data.get.view = view;
      pass_data.get.page = 1;

      response = await api("/outlet/orders", pass_data);
    }

    if (response?.status_code == 200) {
      SetResponseData(response?.response);
      console.log(response?.response);
      // SetOrderData(response?.response?.orders);
      // SetData(response?.response?.options);
    }
    SetIsLoading(false);
  }

  function CallOrderComponent(type_value: any) {
    if (type_value == "active") {
      // order("active")
      // get_order(id_value.type);
      timer = setInterval(() => get_order(id_value.type), 10000);
    } else {
      clearInterval(timer);
      // get_order(id_value.type);
    }
    setType(type_value);

    // get_order(type_value)
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className="mb-5">
      {/* {!have_new_order ? ( */}
        <div
          className="head-bar sm-pb-0" 
          style={width < 780 ? { width: width } : {}}
          >
          <div className="">
              <h6 className="mb-1">Orders</h6>

            {/* <div className="accordion accordion-flush" id="accordionFlushExample"> */}

            {/* </div> */}

            {/* <div className="col-md-1 col-3">
            <div className="d-flex">
              <div
                className="px-2 cursor"
                onClick={() => {
                  // SetListView(true);
                  // SetGridView(false);
                }}
              >
                <MaterialCommunityIcons
                  name="format-list-text"
                  size={20}
                  color={list_view ? "#056aff" : "gray"}
                />
              </div>
              <div
                className="px-2 cursor"
                onClick={() => {
                  // SetListView(false);
                  // SetGridView(true);
                }}
              >
                <MaterialCommunityIcons
                  name="view-grid-outline"
                  size={20}
                  color={grid_view ? "#056aff" : "gray"}
                />
              </div>
            </div>
          </div> */}
            {/* <div className="col-md-5 col-9 ">
            <div className="row px-md-3">
              <div className="input-icons form-group">
                <input
                  type="text"
                  className="form-control search-bar p-0"
                  placeholder="Search products"
                />
                <div className="cursor ps-2 border-left">
                  <Ionicons name="md-search" size={18} color="#663fc3" />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center col-md-1 col-3 ps-1 pe-2">
            <select className="number-select form-select btn-radius form-control pe-0 ps-2" defaultValue="10">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
          </div> */}
          </div>

          <div className="mt-1 d-flex align-items-center bg-fff p-2 sm-px-0 md-px-3 sm-pb-0">
          <div className="d-flex align-items-center scrollX">
          {tab_filter.map((tab, tab_index) => (
            <button
            key={tab_index}
              type="button"
              className={
                active_tab == tab.value
                  ? "btn btn-text header-tap me-1 px-3 pb-2 center"
                  : "btn btn-text text-darkgray me-1 px-3 pb-2 "
              }
              onClick={() => {
                navigate(
                  "/outlet/" +
                    id_value.brand_id +
                    "/" +
                    id_value.outlet_id +
                    "/orders/" +
                    tab.value
                );
                SetIdValue((prevalue:any)=>{
                  prevalue.type = tab.value;
                  return prevalue;
                })
              }}
            >
              {tab.label}
            </button>
          ))}
         
          </div>
        </div>

          {/* <div className="row align-items-cetner pt-3">
            <div className="col-md-10 col-lg-8 p-0 order-alice">
              <AliceCarousel
                mouseTracking
                touchMoveDefaultEvents={false}
                // items={productsRestraunt}
                // paddingLeft={50}
                paddingRight={30}
                disableDotsControls
                responsive={responsive}
                disableButtonsControls
              >
                {tab_filter.map((tab, tab_index) => (
                  <div
                    key={tab_index}
                    className="text-center cursor me-2"
                    onDragStart={handleDragStart}
                  >
                    <div
                      onClick={() => {
                        navigate(
                          "/outlet/" +
                            id_value.brand_id +
                            "/" +
                            id_value.outlet_id +
                            "/orders/" +
                            tab.value
                        );
                        SetIdValue((prevalue:any)=>{
                          prevalue.type = tab.value;
                          return prevalue;
                        })
                      }}
                    >
                      <p
                        className={
                          active_tab == tab.value
                            ? "fw-bold active-tab-view "
                            : "text-gray tab-view"
                        }
                        onClick={() => {
                          // SetActiveTab(tab.value);
                          // get_order(tab.value);
                          if (tab.value == "all") {
                            CallOrderComponent("all");
                          }
                        }}
                      >
                        {tab.label}
                      </p>
                    </div>
                  </div>
                ))}
              </AliceCarousel>
            </div>
          </div> */}





        </div>
      {/* ) : context.app_data.application.platform == "web" ? (
        <div
          className={
            OutletContext ? "head-bar sticky-sm" : "head-bar sticky-sm"
          }
          style={OutletContext == false ? { width: width } : {}}
          onClick={() => {
            navigate(
              "/outlet/" +
                id_value.brand_id +
                "/" +
                id_value.outlet_id +
                "/orders/active"
            );
            SetHaveNewOrder(false);
          }}
        >
          <div
            className="row align-items-center new_header cursor "
            style={width < 548 ? { width: width } : {}}
          >
            <div className="mb-2 col-12 d-flex">
              <h6 className="col-10">New Orders Avilable</h6>
              <div className=" ms-auto">
                <Ionicons name="ios-close" size={20} color="#000" />
              </div>
            </div>
          </div>
        </div>
      ) : null} */}

      <div className="px-1 sm-px-0 my-3">
        <OrderComponent
          data={response_data}
          view={view_type}
          have_new_order={have_new_order}
          is_loading={is_loading}
          on_new_order={(data: any) => {
            SetHaveNewOrder(data);
            // if(data){
            //   get_order(id_value.type);
            // }
          }}
        />
      </div>
      <div className="">
      {context.app_data.application.platform == "web" && have_new_order ? (
        <div
          // className={
          //   OutletContext ? "head-bar sticky-sm" : "head-bar sticky-sm"
          // }
          className="new-order-alert"
          style={OutletContext == false ? { width: width } : {}}
          onClick={() => {
            navigate(
              "/outlet/" +
                id_value.brand_id +
                "/" +
                id_value.outlet_id +
                "/orders/active"
            );
            SetHaveNewOrder(false);
          }}
        >
          <div
            className="row align-items-center new_header cursor "
            style={width < 548 ? { width: width } : {}}
          >
            <div className="mb-2 col-12 d-flex">
              <h6 className="col-10">New Orders Avilable</h6>
              <div className=" ms-auto">
                <Ionicons name="ios-close" size={20} color="#000" />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      </div>
    </div>
  );
}
